module.exports = __webpack_public_path__ + "static/media/menu.b3f7116b.jpg";